/**
 * @file Saga updating a company (`PUT company/:id`, answering `{data: <company>}`) and replacing it in `app.companies`.
 * A refused update runs ErrorHandlerSequence and PAGE_CONTACT_COMPANY_UPDATE_FAILURE.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";
import CompanyFactory from "../../Entity/Factories/CompanyFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { CompanyInterface } from "../../Entity/Entities/Company/CompanyInterface";

export default function* companyUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_CLEAR
    });

    yield put({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_REQUEST
    });

    const res = yield call(Http.put, `company/${action.payload?.id}`, action.payload?.company);
    const company: CompanyInterface = CompanyFactory.create(res.data.data);

    yield put({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_SUCCESS,
      payload: {
        company: company
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-company-updated-successfully"),
        type: "success"
      }
    });

    yield put({
      type: Constants.PAGE_CONTACTS_SWITCH_TAB,
      payload: {
        index: 1
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, company);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchCompanyUpdate() {
  yield takeEvery(Constants.PAGE_CONTACT_COMPANY_UPDATE_START, companyUpdate);
}
